import { valid, coerce, lt } from 'semver';

/**
 * event log snapshot can be truncated when there are too many events
 * this function is used to check if such snapshot is truncated
 * @param {object} eventlog
 * @returns {boolean} true if eventlog is truncated, otherwise false
 */
const isEventLogTruncated = (eventlog) => {
  if (!eventlog) return false;

  return eventlog.truncated === true;
};

/**
 * checks if view log button should be displayed
 * @returns {boolean} true if
 * 1. device is connected
 * 2. user has cm_eventlog permission
 * 3. device is not a es3_28 echo
 * 4. has min ibmsApi version of 3
 */
const shouldShowLogsButton = (device, hasPermission) => {
  if (!device || !hasPermission) {
    return false;
  }
  const deviceType = device?.properties?.reported?.productType;
  if (!deviceType) return false;

  // echo es3_28 does not support logs
  if (deviceType.toUpperCase() === 'ES3_28') return false;
  const ibmsVersionString = device?.properties?.reported?.ibmsApiVersion;
  if (!valid(coerce(ibmsVersionString))) return false;

  const MIN_IBMS_API_VERSION = 'v3';
  if (lt(valid(coerce(ibmsVersionString)), valid(coerce(MIN_IBMS_API_VERSION)))) return false;

  return true;
};

export { isEventLogTruncated, shouldShowLogsButton };
